import axios from '../axios.js'

var platformManagement = {
    // 获取部门列表
    getAllDepartments: function (data, success, failure) {
        return axios.get('/departmentManage/getAllDepartments', data, success, failure)
    },
    // 添加/修改部门
    saveDepartment: function (data, success, failure) {
        return axios.postJson('/departmentManage/saveDepartment', data, success, failure)
    },
    // 删除部门
    deleteDepartment: function (data, success, failure) {
        return axios.post('/departmentManage/deleteDepartment', data, success, failure)
    },
    // 获取部门角色列表
    getAllRoles: function (data, success, failure) {
        return axios.get('/roleManage/getAllRoles', data, success, failure)
    },
    // 获取部门角色列表（分页）
    getRoles: function (data, success, failure) {
        return axios.get('/roleManage/getRoles', data, success, failure)
    },
    // 添加/修改角色
    saveRole: function (data, success, failure) {
        return axios.postJson('/roleManage/saveRole', data, success, failure)
    },
    // 删除角色
    deleteRole: function (data, success, failure) {
        return axios.post('/roleManage/deleteRole', data, success, failure)
    },
    // 获取角色权限
    getRolePermissions: function (data, success, failure) {
        return axios.get('/roleManage/getRolePermissions', data, success, failure)
    },
    // 保存角色权限
    saveRolePermissions: function (data, success, failure) {
        return axios.post('/roleManage/saveRolePermissions', data, success, failure)
    },
    // 改变角色是否可操作项目
    changeRoleProject: function (data, success, failure) {
        return axios.post('/roleManage/changeRoleProject', data, success, failure)
    },
    // 获取角色员工列表（分页）
    getEmployees: function (data, success, failure) {
        return axios.get('/employeeManage/getEmployees', data, success, failure)
    },
    // 添加/修改员工
    saveEmployee: function (data, success, failure) {
        return axios.postJson('/employeeManage/saveEmployee', data, success, failure)
    },
    // 修改员工
    updateMember: function (data, success, failure) {
        return axios.postJson('/employeeManage/updateMember', data, success, failure)
    },
    // 邀请
    inviteMember: function (data, success, failure) {
        return axios.postJson('/employeeManage/inviteMember', data, success, failure)
    },
    // 删除员工
    deleteEmployee: function (data, success, failure) {
        return axios.post('/employeeManage/deleteEmployee', data, success, failure)
    },
    // 获取模板列表
    getIdstTemps: function (data, success, failure) {
        return axios.get('/templateManage/getIdstTemps', data, success, failure)
    },
    // 获取一级投资组合列表
    getFirstPortfolios: function (data, success, failure) {
        return axios.get('/portfolioManage/getFirstPortfolios', data, success, failure)
    },
    // 获取下级投资组合列表
    getNextPortfolios: function (data, success, failure) {
        return axios.get('/portfolioManage/getNextPortfolios', data, success, failure)
    },
    // 保存投资组合
    savePortfolio: function (data, success, failure) {
        return axios.postJson('/portfolioManage/savePortfolio', data, success, failure)
    },
    // 删除投资组合
    deletePortfolio: function (data, success, failure) {
        return axios.post('/portfolioManage/deletePortfolio', data, success, failure)
    },
    // 获取项目过程列表
    getProjProcesses: function (data, success, failure) {
        return axios.get('/processManage/getProjProcesses', data, success, failure)
    },
    // 删除过程
    deleteProcess: function (data, success, failure) {
        return axios.post('/processManage/deleteProcess', data, success, failure)
    },
    // 保存过程
    saveProjProcess: function (data, success, failure) {
        return axios.postJson('/processManage/saveProjProcess', data, success, failure)
    },
    // 获取里程碑模板列表
    getMilestoneTemps: function (data, success, failure) {
        return axios.get('/milestoneTempManage/getMilestoneTemps', data, success, failure)
    },
    // 删除里程碑
    deleteMilestoneTemp: function (data, success, failure) {
        return axios.post('/milestoneTempManage/deleteMilestoneTemp', data, success, failure)
    },
    // 保存里程碑
    saveMilestoneTemp: function (data, success, failure) {
        return axios.postJson('/milestoneTempManage/saveMilestoneTemp', data, success, failure)
    },
    // 获取资源模板列表
    getResourceTemps: function (data, success, failure) {
        return axios.get('/resourceTempManage/getResourceTemps', data, success, failure)
    },
    // 删除资源
    deleteResourceTemp: function (data, success, failure) {
        return axios.post('/resourceTempManage/deleteResourceTemp', data, success, failure)
    },
    // 保存资源
    saveResourceTemp: function (data, success, failure) {
        return axios.postJson('/resourceTempManage/saveResourceTemp', data, success, failure)
    },
    // 获取状态模板列表
    getStatusTemps: function (data, success, failure) {
        return axios.get('/statusTempManage/getStatusTemps', data, success, failure)
    },
    // 删除状态
    deleteStatusTemp: function (data, success, failure) {
        return axios.post('/statusTempManage/deleteStatusTemp', data, success, failure)
    },
    // 保存状态
    saveStatusTemp: function (data, success, failure) {
        return axios.postJson('/statusTempManage/saveStatusTemp', data, success, failure)
    },
    // 获取任务列表模板列表
    getTaskListTemps: function (data, success, failure) {
        return axios.get('/taskListTempManage/getTaskListTemps', data, success, failure)
    },
    // 删除任务列表
    deleteTaskListTemp: function (data, success, failure) {
        return axios.post('/taskListTempManage/deleteTaskListTemp', data, success, failure)
    },
    // 保存任务列表
    saveTaskListTemp: function (data, success, failure) {
        return axios.postJson('/taskListTempManage/saveTaskListTemp', data, success, failure)
    },
    // 项目列表
    getProjectInfoList: function (data, success, failure) {
        return axios.get('/projectManage/getProjectInfoList', data, success, failure)
    },
    // 删除项目
    deleteProjectInfo: function (data, success, failure) {
        return axios.post('/project/deleteProjectInfo', data, success, failure)
    },
    // 修改项目信息
    updateProjectInfo: function (data, success, failure) {
        return axios.post('/projectManage/updateProjectInfo', data, success, failure)
    },
    // 获取订单记录列表
    getSubscribes: function (data, success, failure) {
        return axios.get('/orderManage/getSubscribes', data, success, failure)
    },
    // 获取订单状态列表
    getOrderStatus: function (data, success, failure) {
        return axios.get('/orderManage/getOrderStatus', data, success, failure)
    },
    // 查看退款信息
    getRefundOrder: function (data, success, failure) {
        return axios.get('/orderManage/getRefundOrder', data, success, failure)
    },
    // 获取订单管理列表
    getOrders: function (data, success, failure) {
        return axios.get('/orderManage/getOrders', data, success, failure)
    },
    // 申请退款
    applyRefund: function (data, success, failure) {
        return axios.post('/orderManage/applyRefund', data, success, failure)
    },
    // 取消订单
    cancelOrder: function (data, success, failure) {
        return axios.post('/orderManage/cancelOrder', data, success, failure)
    },
    // 订阅申请
    createOrder: function (data, success, failure) {
        return axios.post('/orderManage/createOrder', data, success, failure)
    },
    // 获取订单支付信息
    getOrderPayInfo: function (data, success, failure) {
        return axios.get('/orderManage/getOrderPayInfo', data, success, failure)
    },
    // 获取任务面板列表
    getTaskBoardList: function (data, success, failure) {
        return axios.get('/taskManage/getTaskBoardList', data, success, failure)
    },
    // 删除任务面板
    deleteTaskBoard: function (data, success, failure) {
        return axios.get('/taskManage/deleteTaskBoard', data, success, failure)
    },
    // 修改任务面板内容
    updateTaskBoard: function (data, success, failure) {
        return axios.get('/taskManage/updateTaskBoard', data, success, failure)
    },
    // 获取任务面板类型
    getTaskBoardTypes: function (data, success, failure) {
        return axios.get('/taskManage/getTaskBoardTypes', data, success, failure)
    },
    // 获取订阅时长列表
    getSubscribeTimes: function (data, success, failure) {
        return axios.get('/orderManage/getSubscribeTimes', data, success, failure)
    },
    // 获取订阅时长列表
    countPrice: function (data, success, failure) {
        return axios.get('/orderManage/countPrice', data, success, failure)
    },
    // 获取企业信息
    getCompanyInfo: function (data, success, failure) {
        return axios.get('/companyManage/getCompanyInfo', data, success, failure)
    },
    // 更新企业logo
    updateCompanyLogo: function (data, success, failure) {
        return axios.post('/companyManage/updateCompanyLogo', data, success, failure)
    },
    // 计算价格（升级企业账号数）
    countUpdateAccountPrice: function (data, success, failure) {
        return axios.post('/companyManage/countUpdateAccountPrice', data, success, failure)
    },
    // 升级确认
    createCompanyOrder: function (data, success, failure) {
        return axios.post('/companyManage/createOrder', data, success, failure)
    },
    // 更新管理者信息
    updateAdminInfo: function (data, success, failure) {
        return axios.post('/companyManage/updateAdminInfo', data, success, failure)
    },
    // 更新企业工作时长
    deleteDepartment2: function (data, success, failure) {
        return axios.post('/companyManage/deleteDepartment', data, success, failure)
    },
    // 更新企业工作时长
    submit2PayOk: function (data, success, failure) {
        return axios.get('/orderManage/submit2PayOk', data, success, failure)
    },
    // 获取企业订阅到期时间
    getCompanyExpiredTime: function (data, success, failure) {
        return axios.post('/companyManage/getCompanyExpiredTime', data, success, failure)
    },
    // 获取企业已使用人数
    getCompanyPersonUsedNum: function (data, success, failure) {
        return axios.post('/companyManage/getCompanyPersonUsedNum', data, success, failure)
    },
    // 更新企业注册地址
    updateCompanyAddr: function (data, success, failure) {
        return axios.post('/companyManage/updateCompanyAddr', data, success, failure)
    },
    // 更新企业注册时间
    updateCompanyRegisterTime: function (data, success, failure) {
        return axios.post('/companyManage/updateCompanyRegisterTime', data, success, failure)
    },
    // 获取成员薪资列表
    getCompanyEmployeeSalaries: function (data, success, failure) {
        return axios.get('/companyEmployeeSalary/getCompanyEmployeeSalaries', data, success, failure)
    },

    // 设置成员薪资
    saveCompanyEmployeeSalary: function (data, success, failure) {
        return axios.postJson('/companyEmployeeSalary/saveCompanyEmployeeSalary', data, success, failure)
    },
    // 获取成员薪资调整历史
    getCompanyEmployeeSalaryHistories: function (data, success, failure) {
        return axios.get('/companyEmployeeSalary/getCompanyEmployeeSalaryHistories', data, success, failure)
    },

    // 获取请假列表
    getEmployeeAskForLeaves: function (data, success, failure) {
        return axios.get("/v2/employeeAskForLeaveManage/getEmployeeAskForLeaves", data, success, failure)
    },

    // 获取加班列表
    getEmployeeOverTimes: function (data, success, failure) {
        return axios.get("/v2/employeeOvertimeManage/getEmployeeOverTimes", data, success, failure)
    },

    // 获取企业成员列表
    getCompanyEmployeesV2: function (data, success, failure) {
        return axios.get("/v2/employee/getCompanyEmployees", data, success, failure)
    },

    // 请假审核
    checkEmployeeAskForLeave: function (data, success, failure) {
        return axios.post("/v2/employeeAskForLeaveManage/checkEmployeeAskForLeave", data, success, failure)
    },

    // 加班审核
    importEmployees: function (data, success, failure) {
        return axios.post("/employeeManage/importEmployees", data, success, failure)
    },
    // 加班审核
    checkEmployeeOvertime: function (data, success, failure) {
        return axios.post("/v2/employeeOvertimeManage/checkEmployeeOvertime", data, success, failure)
    },
    // 取消邀请
    cancelInvite: function (data, success, failure) {
        return axios.post("/employeeManageV2/cancelInvite", data, success, failure)
    },

    /**
     * 获取企业设备列表
     */
    getCompanyDevices: function (data, success, failure) {
        return axios.get("/v2/deviceCompanyManage/getCompanyDevices", data, success, failure)
    },

    /**
     * 添加企业设备
     */
    addCompanyDeviceByMac: function (data, success, failure) {
        return axios.postJson("/v2/deviceCompanyManage/addCompanyDeviceByMac", data, success, failure)
    },

    /**
     * 添加企业设备
     */
    deleteCompanyDevice: function (data, success, failure) {
        return axios.post("/v2/deviceCompanyManage/deleteCompanyDevice", data, success, failure)
    },

    /**
     * 绑定设备
     */
    bindCompanyDevice: function (data, success, failure) {
        return axios.post("/v2/deviceCompanyManage/bindCompanyDevice", data, success, failure)
    },
    /**
     * 解除绑定设备
     */
    unbindCompanyDevice: function (data, success, failure) {
        return axios.post("/v2/deviceCompanyManage/unbindCompanyDevice", data, success, failure)
    },

    /**
     * 获取产品分类
     */
    getDeviceProductTypes: function (data, success, failure) {
        return axios.get("/v2/deviceCompanyManage/getDeviceProductTypes", data, success, failure)
    },

    /**
     * 获取产品尺寸分类
     */
    getDeviceProductScreenTypes: function (data, success, failure) {
        return axios.get("/v2/deviceCompanyManage/getDeviceProductScreenTypes", data, success, failure)
    },

    /**
     * 获取员工报销列表
     */
    getEmployeeExpenses: function (data, success, failure) {
        return axios.get("/v2/employeeExpensesManage/getEmployeeExpense", data, success, failure);
    },

    /**
     * 报销审核
     */
    checkEmployeeExpense: function (data, success, failure) {
        return axios.post("/v2/employeeExpensesManage/checkEmployeeExpense", data, success, failure);
    },

    /**
     * 报销金额发放
     */
    payExpenses: function (data, success, failure) {
        return axios.post("/v2/employeeExpensesManage/payExpenses", data, success, failure);
    },

    /**
     * 报销金额发放
     */
    resetPayExpenses: function (data, success, failure) {
        return axios.post("/v2/employeeExpensesManage/resetPayExpenses", data, success, failure);
    },

    /**
     * 获取企业所有项目列表
     */
    getCompanyAllProjects: function (data, success, failure) {
        return axios.get("/projectManage/getCompanyAllProjects", data, success, failure)
    },

    /**
     * 保存项目资料模版
     */
    saveProjectFileTemp: function (data, success, failure) {
        return axios.postJson("/v2/projectFileTemp/saveProjectFileTemp", data, success, failure)
    },

    /**
     * 获取项目资料模版列表
     */
    getProjectFileTemps: function (data, success, failure) {
        return axios.get("/v2/projectFileTemp/getProjectFileTemps", data, success, failure)
    },

    /**
     * 删除项目资料模版
     */
    deleteProjectFileTemp: function (data, success, failure) {
        return axios.post("/v2/projectFileTemp/deleteProjectFileTemp", data, success, failure)
    },

}

export default platformManagement